<template>
  <div v-if="content">
    <b-tabs v-model="tab_model" nav-class="fixed-tab" content-class="pt-3" class="tabs-sidebar-invitation">
      <b-tab :title="$t('youtube.content')">

        <b-col class="col-12 mb-2 pt-2 border-bottom">
          <b-form-group :label="$t('campaigns.date_publish')"> 
            <b-form-datepicker
              :placeholder="$t('campaigns.date_publish')"
              v-model="date_publish"
              :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit'}"
            ></b-form-datepicker>
             
          </b-form-group>
        </b-col>
        <general-form
          class="col-12"
          :content_dad="content"
          :uuids="{campaign_uuid, campaign_influencer}"
          :net="content.network"
          :info_add="{date_publish}"
          :content_type="content.content_type"
          :code_campaign="campaign.code_campaign || null"
          @closeSidebar="closeSidebar"
        > 
        </general-form>
      </b-tab>
      <b-tab title="Overview">
        <tab-overview :campaign="campaign" :key="tab_model"/>
      </b-tab>
      <b-tab v-if="requirements.length > 0" :title="$t('invitation.requirements')">
        <div v-for="(requirement, index) in requirements" :key="index">
          <div class="m-1" v-html="requirement.form_value"></div>
        </div>
      </b-tab>
      <b-tab v-if="elements.length > 0" :title="$t('invitation.elements')">
        <div v-for="(element, index) in elements" :key="index">
          <div class="m-1" v-html="element.form_value"></div>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { BTabs, BTab, BCol, BFormDatepicker, BFormGroup } from "bootstrap-vue";
import { getDatev2 } from "@/libs/utils/times";
import { getDropdownNetworks } from "@/libs/utils/icons";

export default {
  name: 'detailsContent',
  components: {
    BTabs,
    BTab,
    BCol,
    BFormDatepicker,
    BFormGroup,
    tabOverview: () => import('@/views/pages/invitation/newInvitation/tabOverview.vue'),
    GeneralForm: () => import('@/views/pages/invitation/newInvitation/forms/GeneralForm.vue'),
  },
  props: {
    content: {
      type: Object,
      default: () => {}
    },
    campaign: {
      required: true,
      type: Object,
    }
  },
  data() {
    return {
      requirements: [],
      elements: [],
      campaign_influencer: this.content.campaing_influencer,
      campaign_uuid: this.campaign.uuid,
      date_publish: this.content.published_date,
      tab_model: 0,
    }
  },
  created() {
    if (this.content) {
      this.requirements = this.campaign.custom_fields.filter(item => item.show_link && item.network && item.network === this.content.network && item.type_field === 'requirement')
      this.elements = this.campaign.custom_fields.filter(item => item.show_link && item.network && item.network === this.content.network && item.type_field === 'element')
    }
  },
  methods: {
    closeSidebar(data) {
      this.$emit('updateContent', data)
      this.$emit('closeSidebar');
    },
    formatDate(date_string, has_timezone = false) {
      if (!date_string) return '-'
      const date = new Date(date_string)
      if (!has_timezone) date.setDate(date.getDate() + 1)
      return getDatev2(date)
    },
    getIconNet() {
      return getDropdownNetworks().filter(i => i.value === this.content.network)[0].icon;
    },
  }
};
</script>

<style>
  .fixed-tab {
    position: absolute;
    z-index: 2;
    background: white;
  }
</style>
